const TRANSIENT_APP_CONFIG_ERROR_FRAGMENTS = [
	"failed to fetch",
	"fetch failed",
	"network request failed",
	"network error",
	"load failed",
	"the network connection was lost",
	"timeout",
	"timed out",
	"aborterror",
	"aborted",
] as const;

const asRecord = (value: unknown): Record<string, unknown> =>
	typeof value === "object" && value !== null
		? (value as Record<string, unknown>)
		: {};

export const getErrorMessage = (error: unknown): string => {
	if (error instanceof Error) {
		return error.message;
	}

	const errorRecord = asRecord(error);
	if (typeof errorRecord.message === "string") {
		return errorRecord.message;
	}

	if (typeof error === "string") {
		return error;
	}

	return String(error);
};

export const isTransientAppConfigFetchError = (error: unknown): boolean => {
	const normalizedErrorMessage = getErrorMessage(error).toLowerCase();

	return TRANSIENT_APP_CONFIG_ERROR_FRAGMENTS.some((fragment) =>
		normalizedErrorMessage.includes(fragment),
	);
};

export const serializeAppConfigFetchError = (
	error: unknown,
): Record<string, unknown> => {
	const errorRecord = asRecord(error);
	const serializedError: Record<string, unknown> = {
		errorMessage: getErrorMessage(error),
	};

	if (error instanceof Error && error.name) {
		serializedError.errorName = error.name;
	}
	if (error instanceof Error && error.stack) {
		serializedError.errorStack = error.stack;
	}
	if (typeof errorRecord.code === "string") {
		serializedError.errorCode = errorRecord.code;
	}
	if (typeof errorRecord.details === "string") {
		serializedError.errorDetails = errorRecord.details;
	}
	if (typeof errorRecord.hint === "string") {
		serializedError.errorHint = errorRecord.hint;
	}

	return serializedError;
};
